import { Input } from "antd";
import { forwardRef } from "react";
import "./input_comp.scss";

const InputComp = forwardRef(
  (
    {
      placeholder,
      className,
      type = "text",
      id,
      label,
      layoutClass,
      showCount = false,
      value,
      onChange,
      name,
      maxLength,
      labelClass,
      disabled = false,
      autoFocus = false,
      icon,
      onIconClick,
      // NEW props
      autoComplete,
      inputMode,
      autoCorrect,
      onCopy,
      onPaste,
      onCut,
      readOnly, // ✅ added
      onFocus, // ✅ added
    },
    ref
  ) => {
    const handleInputChange = (e) => {
      if (onChange) onChange(e);
    };

    return (
      <div
        className={`input-comp ${layoutClass || ""} ${
          showCount ? "showCount" : ""
        }`}
      >
        {label && (
          <label className={`${labelClass || "input-label"}`} htmlFor={id}>
            {label}
          </label>
        )}
        <Input
          showCount={showCount}
          disabled={disabled}
          maxLength={maxLength}
          autoFocus={autoFocus}
          type={type}
          name={name}
          value={value}
          id={id}
          placeholder={placeholder}
          onChange={handleInputChange}
          className={className}
          ref={ref}
          suffix={
            icon ? (
              <span
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={onIconClick}
              >
                {icon}
              </span>
            ) : null
          }
          autoComplete={autoComplete}
          inputMode={inputMode}
          autoCorrect={autoCorrect}
          onCopy={onCopy}
          onPaste={onPaste}
          onCut={onCut}
          readOnly={readOnly} // ✅ added
          onFocus={onFocus} // ✅ added
        />
      </div>
    );
  }
);

export default InputComp;
